import React from 'react';
import HeroSection from './HeroSection';
import CategoryBrowse from './CategoryBrowse';
import HowItWorks from './HowItWorks';

function PublicLandingPage() {
  return (
    <>
      <HeroSection />
      <CategoryBrowse />
      <HowItWorks />
    </>
  );
}

export default PublicLandingPage;